/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class InvoiceApi {
    static getInstance() {
        if (!this.instance) this.instance = new InvoiceApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取发票列表
    async getInvoiceList (param, page_num, page_size){
        let url = `/api/invoice/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取订单列表
    async getOrderList (param, num, size){
        let url = `/api/order/head/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取出库单列表
    async getOutboundList (param, num, size){
        let url = `/api/order/stock/out/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 创建发票/重新下载发票
    // async downloadInvoice (param, order_number, delivery_number){
    //     let url = `/api/invoice/download/${order_number}?invoice_child_type=${delivery_number}`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }

    async downloadInvoice (param){
        let url = `/api/invoice/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 重新生成订单发票
    // async genertaeOrderInvoice (param,order_number, delivery_number){
    //     let url = `/api/invoice/rebuild/${order_number}?invoice_child_type=${delivery_number}`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }

    async genertaeOrderInvoice (param){
        let url = `/api/invoice/rebuild`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载预付款发票
    async downloadPrepaidInvoice (prepaid_order_id, param){
        let url = `/api/invoice/download/prepaid/${prepaid_order_id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 重新生成预付款发票
    async rebuildPrepaidInvoice (prepaid_order_id, param){
        let url = `/api/invoice/rebuild/prepaid/${prepaid_order_id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 发送发票到邮箱
    async sendInvoiceToEmail (orderName, delivery_number){
        let url = `/api/order/module/email?order_number=${orderName}&invoice_child_type=${delivery_number}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 删除发票
    async deleteInvoice (order_number, delivery_number){
        let url = `/api/invoice/remove/${order_number}?order_number=${order_number}&invoice_child_type=${delivery_number}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 检验是否可以下载发票
    async validDownloadInvoice (order_id, delivery_number){
        let url = `/api/order/head/${order_id}/check/invoice?id=${order_id}&invoice_child_type=${delivery_number}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 判断发票是否存在
    async validIsExistInvoice (order_id,type,delivery_number){
        let url = `/api/invoice/exist/${order_id}?order_id=${order_id}&type=${type}&invoice_child_type=${delivery_number}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 录入付款金额
    async enterPayAmount (param, id){
        // let url = `/api/invoice/${id}/pay?id=${id}&pay_amount=${pay_amount}`
        let url = `/api/invoice/${id}/pay`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 导出发票列表
    async exportInvoice (param){
        let url = `/api/invoice/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 下载无效发票
    async downloadInvaildInvoice (param){
        let url = `/api/order/module/download/${param.category}`
        let result = await this.getData(url,param,'GET')
        return result
    } 

}

export {
    InvoiceApi
}